import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class ContentBlockService {

  static getContentBlocks(
    standardId,
    period
  ){
    return HttpUtil.get(
      API_ROUTES.CONTENT_BLOCK.GET_CONTENT_BLOCKS
      .replace("<standardId>", standardId)
      .replace("<period>", period)
      .replace("<type>", 0)   
    )
  }

  static getContentBlockDetails(id){
    return HttpUtil.get(
      API_ROUTES.CONTENT_BLOCK.GET_CONTENT_BLOCKS_DETAILS
      .replace("<id>", id)
    )
  }

  static createContentBlock(data){
    return HttpUtil.post(
      API_ROUTES.CONTENT_BLOCK.CREATE_CONTENT_BLOCK, data
    )
  }

  static updateContentBlock(data, id){
    return HttpUtil.put(
      API_ROUTES.CONTENT_BLOCK.UPDATE_CONTENT_BLOCK
      .replace("<id>", id), data
    )
  }

  static deleteContentBlock(id){
    return HttpUtil.delete(
      API_ROUTES.CONTENT_BLOCK.UPDATE_CONTENT_BLOCK
      .replace("<id>", id)
    )
  }
  
  static contentFromFile(form){
    return HttpUtil.postForReportAI(
      API_ROUTES.CONTENT_BLOCK.CONTENT_FROM_FILE, form
    )
  }

  static contentFromUrl(url){
    return HttpUtil.postForReportAI(
      API_ROUTES.CONTENT_BLOCK.CONTENT_FROM_URL, url
    )
  }

  static getContentBlockTopics(standardId){
    return HttpUtil.get(
      API_ROUTES.CONTENT_BLOCK.CONTENT_BLOCK_TOPICS
      .replace("<standardId>", standardId)
    )
  }

  static getContentBlocksForTopic(
    topicId,
    period,
    standardId,
    periodStart = '', periodEnd = ''
  ){
    return HttpUtil.get(
      API_ROUTES.CONTENT_BLOCK.GET_CONTENT_BLOCKS_FOR_TOPIC
      .replace("<standardId>", standardId)
      .replace("<period>", period)
      .replace("<topicId>", topicId)   
      .replace(periodStart && periodEnd ? "<periodStart>" : "?periodStart=<periodStart>", periodStart)
      .replace(periodStart && periodEnd ? "<periodEnd>" : "&periodEnd=<periodEnd>", periodEnd)
    )
  }
}
